import route from "../utils/route";

export default {
    install: (app, options) => {
        app.config.globalProperties.$route = route
    }
}
